export const formatSchedule = (schedule) => schedule?.map((entry) => {
  const days = { L: "Luni", M: "Marți", M2: "Miercuri", J: "Joi", V: "Vineri", S: "Sâmbătă", D: "Duminică" };
  const formatHour = (time: string) => {
    const [hour, minute] = time.split(":");
    return `${parseInt(hour) + 1}:${minute}`;
  };
  return {
    days: entry.days.map((day: string) => days[day === "Miercuri" ? "M2" : day]).join(", "),
    hours: entry.is24Hour ? "NON-STOP" : `${formatHour(entry.startTime)} - ${formatHour(entry.endTime)}`,
    available: !entry.isIndisponible,
  };
});
